import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import {
  MessageBox,
  Message,
  Loading
} from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  timeout: 60000 // request timeout
  // withCredentials: true, // send cookies when cross-domain requests
  // withCredentials: true, //跨域时若要发生cookie,需要设置该选项
})

let elLoading, elMessage;
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.loading && !elLoading) {
      elLoading = Loading.service({
        text: Vue.prototype.$bus.$ts('加载中'),
        background: 'rgba(0, 0, 0, 0.3)',
        spinner: 'el-icon-loading',
      })
    }
    if (!config.data) {
      config.data = {};
    }
    const userState = Vue.prototype.$bus.$store.state.user;
    if(config.data.language===undefined){
      config.data.language = Vue.prototype.$bus.$i18n.locale.toLocaleLowerCase();
    }
    if (config.token) {
      let userInfo = userState.userInfo;
      let access_token = userInfo.access_token;
      config.data.access_token = access_token;
      config.data.token = access_token;
      config.data.uid = userInfo.uid;
      config.data.plat_id = config.data.plat_id||userInfo.plat_id;
      config.data.appid = config.data.appid||userInfo.appid;
    }
    config.method = 'post';
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    let res = response.data;
    if (response.config.loading && elLoading) {
      elLoading.close()
    }
    if (response.status === 200) {
      let errorMsg = '';

      switch (res.error_code) {
        case 0:
          return res
          break;
        case 1:
          errorMsg = res.error_msg;
          break;
        case 401:
          errorMsg = Vue.prototype.$bus.$ts('当前账号已在其它地方登陆，请重新登陆');
          setTimeout(() => {
            location.reload()
          }, 5000)
          break;
        case 500:
          errorMsg = Vue.prototype.$bus.$ts('网络连接异常，请切换页面或重新登录账号');
          break;
        default:
          errorMsg = res.error_msg;
      }

      if (errorMsg && (!elMessage || elMessage.message != errorMsg)) {
        elMessage = Message({
          message: errorMsg,
          type: 'error',
          duration: 5 * 1000,
          onClose() {
            elMessage = null;
          }
        })
      }
      return res

    } else {
      return Promise.reject(response); //失败
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (elLoading) {
      elLoading.close()
    }
    if (!elMessage) {
      elMessage = Message({
        message: Vue.prototype.$bus.$ts('网络请求失败!'),
        type: 'error',
        duration: 5 * 1000,
        onClose() {
          elMessage = null;
        }
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js